import highContrastCssUrl from './css/high-contrast.css?url';
import darkCssUrl from './css/popdock-dark.css?url';
import lightCssUrl from './css/popdock.css?url';
import solarizedDarkCssUrl from './css/solarized-dark.css?url';
import solarizedLightCssUrl from './css/solarized-light.css?url';

const getLightThemeColors = () => {
  return {
    borderColor: '#cccccc',
    mainColor: '#598ccb',
  };
};

const getDarkThemeColors = () => {
  return {
    borderColor: '#111111',
    mainColor: '#446c9d',
  };
};

const getHighContrastThemeColors = () => {
  return {
    borderColor: '#ffff00',
    mainColor: '#00ffff',
  };
};

const getSolarizedLightThemeColors = () => {
  return {
    borderColor: '#839496',
    mainColor: '#073642',
  };
};

const getSolarizedDarkThemeColors = () => {
  return {
    borderColor: '#839496',
    mainColor: '#073642',
  };
};

const getDynamicsBcThemeColors = () => {
  return {
    borderColor: '#B9BEC5',
    mainColor: '#007E87',
  };
};

const getAcumaticaThemeColors = () => {
  return {
    borderColor: '#D8DCDE',
    mainColor: '#000000',
  };
};

const getDynamicsCrmThemeColors = () => {
  return {
    borderColor: '#e1dfdd',
    mainColor: '#4286a6',
  };
};

const getDynamicsGpThemeColors = () => {
  return {
    borderColor: '#adaeb5',
    mainColor: '#4286a6',
  };
};

const getFreshDeskThemeColors = () => {
  return {
    mainColor: '#2F3941',
  };
};

const getIntacctThemeColors = () => {
  return {
    borderColor: '#C9C9C9',
    mainColor: '#181818',
  };
};

const getMaterialThemeColors = () => {
  return {
    borderColor: '#000000',
    mainColor: '#6200EE',
  };
};

const getMsTeamsThemeColors = () => {
  return {
    borderColor: '#F0F2F4',
    mainColor: '#5558AF',
  };
};

const getNetsuiteThemeColors = () => {
  return {
    borderColor: '#E0E0E0',
    mainColor: '#4286A6',
  };
};

const getSalesforceThemeColors = () => {
  return {
    borderColor: '#E0E0E0',
    mainColor: '#4286A6',
  };
};

const getZendeskThemeColors = () => {
  return {
    mainColor: '#00363D',
  };
};

const getZendeskChatThemeColors = () => {
  return {
    borderColor: '#D8DCDE',
    mainColor: '#00363D',
  };
};

const getZendeskSellThemeColors = () => {
  return {
    borderColor: '#D8DCDE',
    mainColor: '#00363D',
  };
};

const getThemeColors = (themeName) => {
  switch (themeName) {
    case Theme.Popdock:
      return getLightThemeColors();
    case Theme.PopdockDark:
      return getDarkThemeColors();
    case Theme.PopdockHighContrast:
      return getHighContrastThemeColors();
    case Theme.PopdockSolarizedDark:
      return getSolarizedDarkThemeColors();
    case Theme.PopdockSolarizedLight:
      return getSolarizedLightThemeColors();
    case Theme.DynamicsBc:
      return getDynamicsBcThemeColors();
    case Theme.Acumatica:
      return getAcumaticaThemeColors();
    case Theme.Zendesk:
      return getZendeskThemeColors();
    case Theme.ZendeskChat:
      return getZendeskChatThemeColors();
    case Theme.DynamicsGp:
      return getDynamicsGpThemeColors();
    case Theme.DynamicsCrm:
      return getDynamicsCrmThemeColors();
    case Theme.FreshDesk:
      return getFreshDeskThemeColors();
    case Theme.Material:
      return getMaterialThemeColors();
    case Theme.Netsuite:
      return getNetsuiteThemeColors();
    case Theme.Salesforce:
      return getSalesforceThemeColors();
    case Theme.MsTeams:
      return getMsTeamsThemeColors();
    case Theme.Intacct:
      return getIntacctThemeColors();
    case Theme.ZendeskSell:
      return getZendeskSellThemeColors();
    default:
      return getLightThemeColors();
  }
};

const setThemeColors = (theme = getHighContrastThemeColors()) => {
  for (const [key, value] of Object.entries(theme)) {
    const cssVarName = `--${key.replace(/([A-Z])/g, '-$1').toLowerCase()}`;
    document.documentElement.style.setProperty(cssVarName, value);
  }
};

//const useThemeTrigger = (parameters) => {

//    const findParameter = (key, parameters) => {
//        const param = parameters.find(p => p.key.toLowerCase() === key.toLowerCase());
//        return param?.value;
//    };

//    const triggerThemeLoad = async (event) => {
//        // if (event.origin !== "EXPECTED_ORIGIN_OF_PARENT")
//        //    return;
//        if (event.data === "triggerAction" && window.popdockBearerToken) {
//            const themeParameter = findParameter(parameters, "theme");
//            await loadTheme(themeParameter);
//        }
//    };

//    useEffect(() => {
//        window.addEventListener("message", triggerThemeLoad);
//        return () => window.removeEventListener("message", triggerThemeLoad);
//    }, [parameters]);
//};

const Theme = {
  Popdock: 'popdock',
  PopdockDark: 'popdock-dark',
  PopdockHighContrast: 'high-contrast',
  PopdockSolarizedLight: 'solarized-light',
  PopdockSolarizedDark: 'solarized-dark',
  DynamicsBc: 'dynamics-bc',
  Acumatica: 'acumatica',
  DynamicsCrm: 'dynamics-crm',
  DynamicsGp: 'dynamics-gp',
  FreshDesk: 'freshdesk',
  Intacct: 'intacct',
  Material: 'material',
  MsTeams: 'ms-teams',
  MsTeamsDark: 'ms-teams-dark',
  Netsuite: 'netsuite',
  Salesforce: 'salesforce',
  Zendesk: 'zendesk',
  ZendeskChat: 'zendesk-chat',
  ZendeskSell: 'zendesk-sell',
  ServiceNow: 'servicenow',
};

const Themes = {
  Popdock: 'Light',
  PopdockDark: 'Dark',
  PopdockHighContrast: 'High contrast',
  PopdockSolarizedLight: 'Solarized light',
  PopdockSolarizedDark: 'Solarized dark',
  DynamicsBc: 'Dynamics 365 Business Central',
  Acumatica: 'Acumatica',
  DynamicsCrm: 'Dynamics 365 Sales',
  DynamicsGp: 'Dynamics GP',
  FreshDesk: 'Freshdesk',
  Intacct: 'Intacct',
  Material: 'Material',
  MsTeams: 'MS Teams',
  MsTeamsDark: 'MS Teams dark',
  Netsuite: 'NetSuite',
  Salesforce: 'Salesforce',
  Zendesk: 'Zendesk',
  ZendeskChat: 'Zendesk Chat',
  ZendeskSell: 'Zendesk Sell',
  ServiceNow: 'ServiceNow',
};

const getThemeOptions = (
  collator,
  includeDefault = false,
  includeEnvironmentThemes = true,
  includePopdockThemes = true,
) => {
  const themes: any = [];

  if (includeDefault) {
    themes.push({ Key: 'default', Value: 'Default from browser settings' });
  }

  if (includePopdockThemes) {
    const popdockThemes = [
      { Key: Theme.Popdock, Value: Themes.Popdock },
      { Key: Theme.PopdockDark, Value: Themes.PopdockDark },
      { Key: Theme.PopdockHighContrast, Value: Themes.PopdockHighContrast },
      { Key: Theme.PopdockSolarizedDark, Value: Themes.PopdockSolarizedDark },
      { Key: Theme.PopdockSolarizedLight, Value: Themes.PopdockSolarizedLight },
    ];
    if (collator) {
      collator.sort(popdockThemes, 'Value');
    }
    if (themes.length > 0) {
      themes.push({ Key: '-', Value: '-' });
    }
    themes.push(...popdockThemes);
  }

  if (includeEnvironmentThemes) {
    const environmentThemes = [
      { Key: Theme.DynamicsBc, Value: Themes.DynamicsBc },
      { Key: Theme.Acumatica, Value: Themes.Acumatica },
      { Key: Theme.Zendesk, Value: Themes.Zendesk },
      { Key: Theme.ZendeskChat, Value: Themes.ZendeskChat },
      { Key: Theme.DynamicsGp, Value: Themes.DynamicsGp },
      { Key: Theme.DynamicsCrm, Value: Themes.DynamicsCrm },
      { Key: Theme.FreshDesk, Value: Themes.FreshDesk },
      { Key: Theme.Material, Value: Themes.Material },
      { Key: Theme.Netsuite, Value: Themes.Netsuite },
      { Key: Theme.Salesforce, Value: Themes.Salesforce },
      { Key: Theme.MsTeams, Value: Themes.MsTeams },
      { Key: Theme.MsTeamsDark, Value: Themes.MsTeamsDark },
      { Key: Theme.Intacct, Value: Themes.Intacct },
    ];
    if (collator) {
      collator.sort(environmentThemes, 'Value');
    }
    if (themes.length > 0) {
      themes.push({ Key: '-', Value: '-' });
    }
    themes.push(...environmentThemes);
  }
  return themes;
};

const themeLinkId = 'sc-active-theme-link';

const applyTheme = (cssUrl: string, bodyClass: string) => {
  // Remove all theme body classes
  document.body.classList.remove(
    'light-theme',
    'dark-theme',
    'high-contrast-theme',
    'solarized-light-theme',
    'solarized-dark-theme',
  );

  // Swap the <link> href — browser loads new CSS and drops the old one automatically
  let link = document.getElementById(themeLinkId) as HTMLLinkElement | null;
  if (!link) {
    link = document.createElement('link');
    link.id = themeLinkId;
    link.rel = 'stylesheet';
    document.head.appendChild(link);
  }
  link.href = cssUrl;
  console.log(cssUrl, bodyClass);

  document.body.classList.add(bodyClass);
};

const loadTheme = async (theme) => {
  const prefersDark =
    window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
  switch (theme) {
    case 'light':
    case 'popdock':
    case 'popdock-light':
    case 'popdock_light':
      applyTheme(lightCssUrl, 'light-theme');
      break;
    case 'dark':
    case 'popdock_dark':
    case 'popdock-dark':
      applyTheme(darkCssUrl, 'dark-theme');
      break;
    case 'high-contrast':
    case 'high_contrast':
    case 'contrast':
      applyTheme(highContrastCssUrl, 'high-contrast-theme');
      break;
    case 'solarized_light':
    case 'solarized-light':
      applyTheme(solarizedLightCssUrl, 'solarized-light-theme');
      break;
    case 'solarized-dark':
    case 'solarized_dark':
      applyTheme(solarizedDarkCssUrl, 'solarized-dark-theme');
      break;
    default:
      if (prefersDark) {
        applyTheme(darkCssUrl, 'dark-theme');
      } else {
        applyTheme(lightCssUrl, 'light-theme');
      }
      break;
  }
};

export { Theme, Themes, getThemeColors, getThemeOptions, loadTheme, setThemeColors };
